<span #successHeading tabindex="-1" class="visually-hidden">Alert Success</span>
<div class="text-center">
    <i role="img" aria-label="success" class="fa-solid fa-circle-check mt-2 mb-4"></i>
    <h2 *ngIf="!state?.isEditOrder">Your order has been placed!</h2>
    <h2 *ngIf="state?.isEditOrder">Order has been successfully updated!</h2>
    <div class="text-center mb-3">
        <label>Here are the details of your order confirmation.</label>
    </div>
<label><span class="medium-text">Order Number:</span> {{state?.orderNumber}}</label><br/>
<label><span class="medium-text">Order Date:</span> {{state?.orderedDate | date:'MM/dd/yyyy' }}</label><br/>
<label><span class="medium-text">Claim Number:</span> {{state?.claimNumber}}</label><br/>
<label><span class="medium-text">Date of Incident:</span> {{state?.incidentDate | date:'MM/dd/yyyy'}}</label><br/>

</div>
